export default "__VITE_ASSET__ByJwn530__"